// pages/Home.js
import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import CountdownTimer from '../components/CountdownTimer';
import AboutSection from '../components/AboutSection';
import VideoSection from '../components/VideoSection';
import ScheduleSection from '../components/ScheduleSection';
import Separator from '../components/Separator';
import Separator2 from '../components/Separator2';
import Carousel from '../components/Carousel';
import Contact from '../components/Contact';

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="home-page">
      <HeroSection />

      <Carousel />
      <AboutSection />
      <Separator />
      <VideoSection />
      <Contact />
      <Carousel />
    </div>
  );
}

export default Home;
